import { fetchApi } from 'shared/functions';

export const fetchUserImage = async (userId, clearBlob = false) => {
  try {
    const response = await fetchApi(`/sso/social/users/${userId}/image`);

    if (!response.ok) {
      throw new Error('Network response was not ok.');
    }

    const blob = await response.blob();

    if (clearBlob) {
      blob.lastModifiedDate = new Date();
      return blob;
    }

    return window.URL.createObjectURL(blob);
  } catch (e) {
    throw new Error('Network response was not ok.');
  }
};
